/**
 * État vide / erreur du widget météo : un encart discret avec message contextuel
 * (commune non renseignée, geocoding indispo, service météo down…). Pas de
 * bouton retry — React Query gère le retry transparent via `staleTime`.
 */

export function MeteoEtatVide({ message }: { message: string }) {
  return (
    <div className="flex min-h-[120px] items-center justify-center rounded-md border border-dashed border-champagne-200 px-4 py-6 text-center text-[13px] text-champagne-700">
      {message}
    </div>
  );
}
